export default __webpack_public_path__ + "static/media/Narekovalnik_prepisovanje_v_zivo.8c58742f.png";